import store from "../store/index";
import {
    callProc,
    apiParam,
    apiPType,
} from "@/services/APointAPI";
import { errorReceived } from "./apointUtil";

export function getWorkerData() {
    let procParams = [
        apiParam("UserName", store.state.api.User.userName, apiPType.NVarChar),
        apiParam("UserPswd", store.state.api.User.pswd, apiPType.NVarChar),
    ];
    return callProc("WorkerApp_GetWorkerData", procParams)
        .then((result) => {
            result = JSON.parse(result);
            // console.log(result);
            store.commit("api/setSessionData", {
                workerID: result.Table[0].Num,
                workerGUID: result.Table[0].GUID,
                openServiceCallsCnt: result.Table1[0].openServiceCallsCnt,
                allowReceptionistModule: result.Table2[0].allowReceptionistModule != 0,
                showChecksDeposit: result.Table2[0].showChecksDeposit != 0
            });
            return result
        })
        .catch((err) => {
            errorReceived("WorkerApp_GetWorkerData", err);
        });
}

export function LogData(message) {
    let procParams = [apiParam("message", message, apiPType.NVarChar)];
    callProc("LogData", procParams);
}